var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-card-v2-attachment--item__container" },
    [
      _c("ObjectLink", {
        attrs: {
          label: _vm.relatedName,
          link: _vm.linkName,
          icon: _vm.icon,
          size: "small"
        }
      }),
      _vm._v(" "),
      _vm.clipboardPhoneEnabled
        ? [
            _vm.item.tel
              ? _c("InteractiveInfo", {
                  attrs: {
                    type: "phone",
                    values: [_vm.item.tel],
                    size: "extra-small"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.item.mobile
              ? _c("InteractiveInfo", {
                  attrs: {
                    type: "mobile",
                    values: [_vm.item.mobile],
                    size: "extra-small"
                  }
                })
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.item.email && _vm.clipboardEmailEnabled
        ? _c("InteractiveInfo", {
            attrs: {
              type: "email",
              values: [_vm.item.email],
              size: "extra-small"
            },
            on: { sendEmail: _vm.handleSendEmail }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }